import React, { useState, useEffect } from 'react';
import {
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  HStack,
  Icon,
  Text,
  Badge,
  useColorModeValue,
} from '@chakra-ui/react';
import { useSearchParams } from 'react-router-dom';
import { MdSettings, MdAttachMoney } from 'react-icons/md';
import SiteSettingsForm from './components/SettingsTable';
import CurrencyManager from './components/CurrencyManager';

export default function SettingsView() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const initialIndex = tabParam === 'currencies' ? 1 : 0;
  const [tabIndex, setTabIndex] = useState(initialIndex);

  useEffect(() => {
    if (tabParam === 'currencies') {
      setTabIndex(1);
    } else {
      setTabIndex(0);
    }
  }, [tabParam]);

  const handleTabsChange = (index) => {
    setTabIndex(index);
    if (index === 1) {
      setSearchParams({ tab: 'currencies' });
    } else {
      setSearchParams({});
    }
  };

  const bgActiveTab = useColorModeValue('white', 'navy.800');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Tabs
        variant="enclosed"
        colorScheme="brand"
        index={tabIndex}
        onChange={handleTabsChange}
      >
        <TabList mb="24px" borderColor={borderColor}>
          <Tab
            fontWeight="bold"
            fontSize="sm"
            _selected={{ color: 'brand.500', bg: bgActiveTab, borderColor: borderColor, borderBottomColor: 'transparent' }}
          >
            <HStack spacing={2}>
              <Icon as={MdSettings} />
              <Text>Site & Branding</Text>
            </HStack>
          </Tab>

          <Tab
            fontWeight="bold"
            fontSize="sm"
            _selected={{ color: 'brand.500', bg: bgActiveTab, borderColor: borderColor, borderBottomColor: 'transparent' }}
          >
            <HStack spacing={2}>
              <Icon as={MdAttachMoney} />
              <Text>Currencies & Fiscal (ارزها و مالیات)</Text>
              <Badge colorScheme="purple" fontSize="10px" borderRadius="full" px={2}>
                Multicurrency
              </Badge>
            </HStack>
          </Tab>
        </TabList>

        <TabPanels>
          <TabPanel p={0}>
            <SiteSettingsForm />
          </TabPanel>

          <TabPanel p={0}>
            <CurrencyManager />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
